export enum ApplicationStatusEnum {
    PENDING = 'PENDING',
    SHORT_LISTED = 'SHORT_LISTED',
    NOT_SELECTED = 'NOT_SELECTED',
    FINALIST = 'FINALIST',
    INTERVIEWED_BY_SAUD = 'INTERVIEWED_BY_SAUD',
    ONBOARDING = 'ONBOARDING',
    CUSTOM = 'CUSTOM', /// Used for custom application stages that are tied to stageId 
}

export enum ApplicantRelevancyEnum {
    RELEVANT = 'RELEVANT',
    IRRELEVANT = 'IRRELEVANT',
    UNREAD = 'UNREAD',
    UNLOCKED = 'UNLOCKED',
}